import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICategoriesMenuState, ICategoriesMenuDropdown } from "../../../types/categoriesMenu/categoriesMenuInterfaces";

export const initialState: ICategoriesMenuState = {
    categoriesMenuDropdown: []
}

export const categoriesMenuSlice = createSlice({
    name: 'categoriesMenu',
    initialState,
    reducers: {
        loadingCategoriesMenuDropdown: (state, action: PayloadAction<ICategoriesMenuDropdown[]>) => {
            state.categoriesMenuDropdown = action.payload;
        },
    }
});

export const { loadingCategoriesMenuDropdown } = categoriesMenuSlice.actions;

export default categoriesMenuSlice.reducer;